import { inject } from 'mobx-react';
import React, { Component } from 'react';
import LoginBanner from './loginBanner';
import LogoImage from './logoImage';
@inject('translationsStore') 
export default class SharedLoginForm extends Component {

    logoStyle = {
        width: '335px',
        height: '50px',
        marginTop: '50px',
        textAlign: 'center'
    };

    render() {
        return (
            <div className='login-main-wrapper'>
                <div className='wrapper-left'>
                    <div className='forms-wrapper'>
                        <LogoImage style={this.logoStyle} />
                        {this.props.component}
                    </div>
                </div>
                <LoginBanner/>
            </div>
        );
    }
}